<template>
<el-container class="container-list is-vertical" style="height: 100%; width: 100%; position: fixed;">
  <top-header>
    <template slot="left">
      <!-- <el-input @keyup.enter.native="search" @input="delaySearch" style="width: 240px;" placeholder="搜尋" v-model="keyword" class="input-with-select">
        <el-button @click="search" slot="append" icon="el-icon-search"></el-button>
      </el-input> -->
      <h1 class="data-page-title">商品類別</h1>

    </template>
    <template slot="right">
      <el-button @click="onCreate" style="margin-right: 20px;">新增</el-button>
    </template>
  </top-header>
  <el-container>

    <left-menu/>

    <el-main v-loading="isLoading">
      <el-table :data="tableData" stripe height="calc(100% - 40px)">
        <template slot="empty">
          沒有資料
        </template>
        <el-table-column label="群組" min-width="150px">
          <template slot-scope="scope">
            {{getGroupTitle(scope.row.GroupID)}}
          </template>
        </el-table-column>
        <el-table-column label="排序" width="60px">
          <template slot-scope="scope">
            {{scope.row.SortOrder}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="名稱" min-width="150px">
          <template slot-scope="scope">
            {{scope.row.TitleTw}}
          </template>
        </el-table-column> -->
        <el-table-column label="繁中" min-width="150px">
          <template slot-scope="scope">
            {{scope.row.TitleTw}}
          </template>
        </el-table-column>
        <el-table-column label="日文" min-width="150px">
          <template slot-scope="scope">
            {{scope.row.TitleJp}}
          </template>
        </el-table-column>
        <el-table-column label="英文" min-width="150px">
          <template slot-scope="scope">
            {{scope.row.TitleEn}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="權重" width="50px">
          <template slot-scope="scope">
            <p style="text-align: right;">{{scope.row.Weigh}}</p>
          </template>
        </el-table-column>
        <el-table-column label="置頂" width="50px">
          <template slot-scope="scope">
            <p v-if="scope.row.IsTop" class="deployed" style="text-align: center;">✓</p>
            <p v-else class="draft"></p>
          </template>
        </el-table-column> -->
        <el-table-column label="狀態" width="70px">
          <template slot-scope="scope">
            <p v-if="scope.row.PublishStatus == 1" class="deployed">發佈</p>
            <p v-else class="draft">下架</p>
          </template>
        </el-table-column>
        <!-- <el-table-column label="最後更新時間" width="170px">
          <template slot-scope="scope">
            {{scope.row.UpdatedAt | moment}}
          </template>
        </el-table-column> -->
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <el-button
              v-show="canModify(scope.row)"
              size="mini"
              round
              @click="onUpdate(scope.row)">編輯</el-button>

            <el-button
              v-show="canModify(scope.row)"
              size="mini"
              type="danger"
              icon="el-icon-delete"
              circle
              @click="askToDelete(scope.$index, scope.row)">
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="prev, pager, next"
        :currentPage="currentPage"
        :page-size="20"
        :total="searchedObjs.length"
        @current-change="onChangePage">
      </el-pagination>

      <product-category-editor-modal :isShow="isShowAddeditModal" @close="isShowAddeditModal = false" @submitted="onObjAddedited" :ori-obj="editingObj"/>

    </el-main>
  </el-container>
</el-container>
</template>

<script>
import LeftMenu from '@/views/components/LeftMenu.vue'
import TopHeader from '@/views/components/TopHeader.vue'
import ProductCategoryEditorModal from '@/data/productCategory/view/editor-modal.vue'
// svgs
import '@/assets/svgs/index.js'

// mixin
import MixinLanguages from '@/utils/mixin-languages.vue'
import MixinFilters from '@/utils/filters/filter-mixin.vue'
import MixinDelaySearch from '@/utils/mixin-delaysearch.vue' // filterObjs method required
export default {
  mixins: [MixinLanguages, MixinFilters, MixinDelaySearch],
  components: {
    LeftMenu,
    TopHeader,
    ProductCategoryEditorModal
  },
  data () {
    return {
      tableData: [],
      currentPage: 1,
      isLoading: false,
      // 篩選
      filteringStatus: null,
      filteringDateRange: null,
      // modal
      isShowAddeditModal: false,
      editingObj: null
    }
  },
  computed: {
    dataList() {
      return this.$store.state.productCategory.list.sort((o1,o2)=>{
        let group1 = (this.$store.state.productCategoryGroup.list.find(o => o.ID === o1.GroupID) || {})
        let group2 = (this.$store.state.productCategoryGroup.list.find(o => o.ID === o2.GroupID) || {})
        if(group1.SortOrder != group2.SortOrder) return group1.SortOrder - group2.SortOrder
        return o1.SortOrder != o2.SortOrder
      })
    }
  },
  methods: {
    canModify (obj) {
      // 62 是加價購專區
      return ![12, 13, 14, 15, 16, 62].includes(obj.ID)
    },
    onCreate () {
      this.editingObj = null
      this.isShowAddeditModal = true
    },
    onUpdate (obj) {
      this.editingObj = obj
      this.isShowAddeditModal = true
    },
    onObjAddedited () {
      this.searchWithoutAlertResult()
    },
    onChangePage (page) {
      this.currentPage = page
      this.tableData = this.searchedObjs.slice((page - 1) * 20, page * 20)
    },
    filterObjs () {
      if (!this.keyword && !this.filteringStatus && !this.filteringDateRange) {
        this.searchedObjs = this.dataList
        return
      }

      const isObjFitKeyword = o => {
        if (!this.keyword) return true
        if (o.TitleTw && o.TitleTw.includes(this.keyword)) return true
        if (o.TitleCn && o.TitleCn.includes(this.keyword)) return true
        if (o.TitleEn && o.TitleEn.includes(this.keyword)) return true
        if (o.TitleJp && o.TitleJp.includes(this.keyword)) return true
        return false
      }

      const isObjFitStatus = o => {
        if (!this.filteringStatus) return true
        if (this.filteringStatus === '全部') return true
        return o.IsActive === (this.filteringStatus === '已發佈')
      }

      this.searchedObjs = this.dataList.filter(u => {
        return isObjFitKeyword(u) && isObjFitStatus(u)
      })
    },
    askToDelete (idx, obj) {
      this.$confirm(`確定刪除 「${obj.TitleTw}」?`, '刪除確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deleteObj(obj)
      })
    },
    deleteObj (obj) {
      this.$services.productCategory.delete(this, obj.ID).then(res => {
        let ok = res && res.data && res.data.status === 'ok'
        if (ok) {
          let idx = this.dataList.findIndex(
            o => o.ID === obj.ID
          )
          if (idx >= 0) this.dataList.splice(idx, 1)
          this.filterObjs()
          this.tableData = this.searchedObjs.slice(
            (this.currentPage - 1) * 20,
            this.currentPage * 20
          )
          this.$message({
            message: `刪除成功`,
            type: 'success'
          })
        }
      }).catch(this.$handleServiceError)
    },
    getGroupTitle (id) {
      return (this.$store.state.productCategoryGroup.list.find(o => o.ID === id) || {}).TitleTw
    }
  },
  created () {
    const initTableData = () => {
      this.searchedObjs = this.dataList
      this.tableData = this.searchedObjs.slice(0, 20)
    }
    // query...
    let promise1 = this.$services.productCategoryGroup.getAll(this).then(res => {
      this.$store.state.productCategoryGroup.list = res.data.result
    })
    let promise2 = this.$services.productCategory.getAll(this).then(res => {
      this.$store.state.productCategory.list = res.data.result
    })

    Promise.all([promise1, promise2]).then(res => {
      initTableData()
    }).catch(this.$handleServiceError)
  }
}
</script>

<style>
.draft {
  color: #666;
  font-weight: 300;
}
.deployed {
  color: #60af4d;
  font-weight: 700;
}
</style>
